import React, { useState, useEffect, useRef } from "react";
import Menu from './Menu'
import InnerHTML from "dangerously-set-html-content";
import { Col, Row, Card, Container } from "react-bootstrap";

const BorrowerForgotPasswordPage = (props) => {

  let html = `<script id="zeitrotag" src=`+props.appUrl+ `/api/zeitrotag.js?customerid=`+ props.customerid+ `&loid=&pageid=recover> </script>`;


  return (
    <div>
      <Menu noLogout={true}/>
      <div className="mt-5">
        <Container>
          <Row className="text-center mb-1">
            <Col>
              <h1>Recover Password</h1>
            </Col>
          </Row>
        <InnerHTML html={html} />

        </Container>
      </div>
    </div>
  );
};

export default BorrowerForgotPasswordPage;
